<h1 mat-dialog-title>Unsaved Changes</h1>
<div mat-dialog-content>
  <p>You have unsaved changes!</p>
  <p>Are you sure you wish to continue? All changes will be lost.</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="'cancel'">Cancel</button>
  <button mat-button [mat-dialog-close]="'confirm'" cdkFocusInitial>Confirm</button>
</div>